'use strict';

class FormularioEmpController {
    constructor($scope, $q, DataService, Storage, Sidenav, Modal, Message, apiUrl, baseUrl, Filter, Util, helpLang, errorsLang, $log) {
        'ngInject';

        this.$scope = $scope;
        this.DataService = DataService;
        this.Storage = Storage;
        this.Modal = Modal;
        this.apiUrl = apiUrl;
        this.baseUrl = baseUrl;
        this.Sidenav = Sidenav;
        this.Message = Message;
        this.Util = Util;
        this.Filter = Filter;
        this.$q = $q;
        this.errorsLang = errorsLang;
        this.helpLang = helpLang;
        this.$log = $log;

        this.usuario = this.Storage.getUser();

        this.renderInsumos = false;
        this.renderPagos = false;

        this.btnSave = false;
        this.btnSend = false;

        this.inputsRequired = ['nombre_producto', 'capacidad_prod_mensual', 'precio_unitario', 'tipo_comercio', 'desc_produccion'];

        this.opcionesLugar = [
            {
                key: 'ETIQUETAS',
                label: 'Etiquetas'
            }, {
                key: 'ENVASES',
                label: 'Envases'
            }, {
                key: 'CARTELES',
                label: 'Carteles'
            }, {
                key: 'VIDEOS',
                label: 'Videos'
            }, {
                key: 'PELICULAS',
                label: 'Películas'
            }, {
                key: 'OTROS',
                label: 'Otros'
            },
        ]
        this.lugaresSeleccionados = {};
    }

    $onInit() {
        this.certificacion = this.Storage.get('matricula_seleccionada');

        this.matricula = this.Storage.get('matriculaPromueve');

        this.producto = {
            id_producto: 25
        };

        this.$scope.$on('app_sello_modal_success', () => { this.atras(); });

        // this.urlUpload = `${this.apiUrl}certificacion_promueve/${this.certificacion.id_unidad_productiva}/producto/${this.producto.id_producto}/guardar-foto`;

        this.insumos = {
            permission: {
                filter: false
            },
            data: {
                formly: [
                    {
                        key: 'id_insumo',
                        type: 'input',
                        templateOptions: {
                            label: 'ID'
                        }
                    },
                    {
                        key: 'tipo_item',
                        type: 'select',
                        templateOptions: {
                            label: 'Ítem',
                            placeholder: 'Nombre de ítem',
                            required: true,
                            options: [
                                {
                                    "value": "MATERIA_PRIMA_DIRECTA",
                                    "name": "Materia prima directa"
                                },
                                {
                                    "value": "MATERIA_PRIMA_INDIRECTA",
                                    "name": "Materia prima indirecta"
                                },
                                {
                                    "value": "MANO_OBRA",
                                    "name": "Mano de obra"
                                },
                                {
                                    "value": "OTROS_COSTOS",
                                    "name": "Otros costos"
                                }
                            ],
                            onChange: (value, options, _this) => {
                                if (value == 'MANO_OBRA') {
                                    _this.model.nacional = true;
                                    _this.model.unidad = 700;
                                    _this.model.unidad_medida = 'Personas';
                                } else {
                                    _this.model.unidad = null;
                                    _this.model.unidad_medida = '';
                                }
                            },
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."'
                            }
                        }
                    },
                    {
                        key: 'descripcion',
                        type: 'input',
                        templateOptions: {
                            label: 'Descripción',
                            placeholder: 'Descripción',
                            required: true,
                            maxlength: 100
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."',
                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
                            }
                        }
                    },
                    {
                        key: 'cantidad',
                        type: 'input',
                        templateOptions: {
                            label: 'Cantidad',
                            placeholder: 'Cantidad',
                            required: true,
                            onKeydown: (value, options, _this, event) => {
                                this.Filter.decimalFormat(event, 10);
                            },
                            onKeyup: (value, options, _this) => {
                                this.calcularTotalInsumo(_this.model);
                            },
                            maxlength:7
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."',
                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
                            }
                        }
                    },
                    {
                        key: 'unidad',
                        type: 'select',
                        templateOptions: {
                            label: 'Unidad de medida',
                            placeholder: 'Unidad de medida',
                            required: true,
                            options: [],
                            // onChange: (value, options, _this, e) => {
                            //     console.log(value, options, _this);
                            // }
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."'
                            }
                        },
                        hideExpression: "model.unidad == '700' && model.unidad_medida == 'Personas'"
                    },
                    {
                        key: 'unidad_medida',
                        type: 'input',
                        templateOptions: {
                            label: 'Otra unidad',
                            placeholder: 'Escriba la unidad de medida',
                            required: true,
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."'
                            }
                        },
                        hideExpression: "model.unidad != '700'",
                        expressionProperties: {
                            "templateOptions.disabled": "model.unidad == '700' && model.unidad_medida == 'Personas'"
                        }
                    },
                    {
                        key: 'valor',
                        type: 'input',
                        templateOptions: {
                            type: 'text',
                            label: 'Valor (bs.)',
                            placeholder: 'Valor (bs.)',
                            required: true,
                            onKeydown: (value, options, _this, event) => {
                              this.Filter.decimalFormat(event, 10);
                            },
                            onKeyup: (value, options, _this) => {
                                this.calcularTotalInsumo(_this.model);
                            },
                            maxlength: 10
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."',
                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
                            }
                        }
                    },
                    {
                        key: 'total',
                        type: 'input',
                        templateOptions: {
                            type: 'text',
                            label: 'Total(bs)',
                            placeholder: 'Total(bs)',
                            required: true,
                            onKeydown: (value, options, _this, event) => {
                                this.Filter.decimalFormat(event);
                            },
                            maxlength: 24,
                            disabled: true
                        },
                        validation: {
                            messages: {
                                required: 'to.label + " es obligatorio."',
                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
                            }
                        }
                    },
                    {
                        key: 'nacional',
                        type: 'radio',
                        defaultValue: true,
                        templateOptions: {
                            label: 'Producto nacional',
                            options: [
                                { 'value': true, 'name': 'Es nacional' },
                                { 'value': false, 'name': 'Es extranjero' }
                            ]
                        },
                        expressionProperties: {
                            "templateOptions.options": (value, options, _this) => {
                                if (_this.model.tipo_item == 'MANO_OBRA') {
                                    return [{ 'value': true, 'name': 'Es nacional' }];
                                } else {
                                    return [
                                        { 'value': true, 'name': 'Es nacional' },
                                        { 'value': false, 'name': 'Es extranjero' }
                                    ];
                                }
                            }
                        }
                    }
                ],
                list: [],
                urlUpdate: ''
            },
            fks: ['tipo_item', 'unidad'],
            // fields: ['id_insumo', 'tipo_item', 'descripcion', 'cantidad', 'unidad', 'unidad_medida', 'valor', 'total', 'nacional']
            hiddenFields: ['unidad_medida'],
            mergeFields: {
                unidad: function (item) {
                    if (item.unidad == 'Otros') {
                        return item.unidad_medida;
                    }
                    return item.unidad;
                }
            }
        };
        this.cargarData();





        this.total = {
            save: list => {
                this.$log.log('list update', list);
                let total = 0;
                list.map(e => {
                    total += parseFloat(e.total);
                });
                this.data.total_costo_bruto = total;

                let valor = 0;
                list.map(e => {
                    valor += parseFloat(e.valor);
                });
                this.data.total_valor_costo_bruto = valor;

                this.guardarForm();
            }
        };

    }

    calcularTotalInsumo(model) {
        let cantidad = model.cantidad ? parseFloat(model.cantidad) : 0;
        let valor = model.valor ? parseFloat(model.valor) : 0;
        model.total = (cantidad * valor).toFixed(2);
    }

    cargarData() {
        this.unidades_comercio = [{
            id_parametro: 'NACIONAL',
            nombre: 'NACIONAL'
        },
        {
            id_parametro: 'EXTRANJERO',
            nombre: 'EXTRANJERO'
        },
        {
            id_parametro: 'NACIONAL_Y_EXTRANJERO',
            nombre: 'NACIONAL Y EXTRANJERO'
        }
        ];

        var idCertificacion = this.Storage.get('editCertificacion');
        if (idCertificacion) {
            this.DataService.get(`cert_sello_bolivia/solicitarAutorizacion/${idCertificacion}`)
            .then(response => {
                if (response) {
                    this.data = response;

                    var productoData = Object.assign({}, this.data.producto);
                    this.data = Object.assign(this.data, productoData);

                    if (this.data.autorizacionSHB && this.data.autorizacionSHB.ubicacionASHB) {
                        var ubicacionesSeleccionadas = this.data.autorizacionSHB.ubicacionASHB.split(',');
                        for (var i = 0; i <= ubicacionesSeleccionadas.length - 1; i++) {
                            this.lugaresSeleccionados[ubicacionesSeleccionadas[i].trim()] = true;
                        }
                    }
                    this.data.medicamento = this.data.producto.medicamento === null ? '' : this.data.producto.medicamento.toString();
                    this.data.insumos = (this.data.produccionBien || []).map(item => {
                        const tmpObj = {};
                        tmpObj.cantidad = item.cantidad.toString();
                        tmpObj.descripcion = item.descripcion.toString();
                        tmpObj.id_insumo = Math.floor(Math.random()* 1000000).toString();
                        tmpObj.nacional = item.produccionNacional;
                        tmpObj.new = true;
                        tmpObj.tipo_item = item.tipoItem;
                        tmpObj.total = item.total.toString();
                        tmpObj.unidad = item.codigoUnidadMedida;
                        tmpObj.unidad_medida = item.otrosUnidadMedida ? item.otrosUnidadMedida.toString() : "";
                        tmpObj.valor = item.valor.toString();
                        return tmpObj;
                    });

                    for(var j = 0; j<= this.data.insumos.length - 1; j++) {
                        this.data.insumos[j].unidad = this.data.insumos[j].unidad.toString();
                    }


                    this.insumos.data.list = this.data.insumos;


                    // Cargar imagenes
                    var imagenes = document.getElementsByClassName('previewImagenes');

                    if (this.data.imagenProducto){
                        imagenes[0].src = this.data.imagenProducto;
                    }

                    if (this.data.imagenUbicacionSello) {
                        imagenes[1].src = this.data.imagenUbicacionSello;
                    }

                    if (this.data.imagenEtiqueta) {
                        imagenes[2].src = this.data.imagenEtiqueta;
                    }
                    this.cargarUnidades();

                } else {
                    this.Sidenav.path('bandejaSello');
                }
            });
        } else {
            this.data = {};
            this.data.insumos = [];
            this.insumos.data.list = this.data.insumos;
            this.cargarUnidades();
        }

        this.DataService.get(`certificacion_promueve/producto/unidades_peso`)
        .then(response => {
            response.unshift({ id_parametro: null, nombre: 'Ninguno' });
            this.unidades_peso = response;
            this.$scope.$watch('$ctrl.data.fid_par_unidadMedida', (newValue, oldValue) => {
                if (angular.toJson(newValue) != angular.toJson(oldValue)) {
                    if (newValue!=700) {
                        this.guardarForm();
                    }
                }
            })
        });
    }


    guardarData (type = 'TEMPORAL') {
        try {
            if (this.data && this.data.unidadmedidapeso === 700) {
                if ((this.data.otrosUnidadMedida || '').trim().length === 0) {
                    this.Message.error('Selecciono otra unidad de medida pero le falta colocar el detalle de esa seleccion');
                    return;
                }
            }
            var data = {};
            data.nroSecuencia = null;
            data.nroSolicitud = null;
            data.proveedor = {
                idCertificado: this.certificacion.id_certificacion
            };
            data.producto = Object.assign({}, this.data);
            if (data.producto) {
                data.producto.peso = parseFloat(data.producto.peso);
                data.producto.precioUnitario = parseInt(data.producto.precioUnitario);
                data.producto.capacidadProduccionMensual = parseInt(data.producto.capacidadProduccionMensual);
                data.producto.medicamento = (typeof data.producto.medicamento === 'undefined' || data.producto.medicamento === '') ? null : data.producto.medicamento === 'true';
                delete data.producto.finalizado;
                delete data.producto.mensaje;
                delete data.producto.datos;
                delete data.producto.fecha;
                delete data.producto.pagos;
                delete data.producto.insumos;
            }

            delete data.producto.autorizacionSHB;
            delete data.producto.producto;
            delete data.producto.proveedor;

            if (this.data && this.data.insumos) {
                data.produccionBien = this.data.insumos;
            } else {
                data.produccionBien = null;
            }

            if (Array.isArray(data.produccionBien)) {
                data.produccionBien = data.produccionBien.map(item => {
                    var objTmp = {};

                    objTmp.idInsumo = Math.floor(Math.random() * 1000000),
                    objTmp.tipoItem = item.tipo_item,
                    objTmp.descripcion = item.descripcion,
                    objTmp.cantidad = parseFloat(item.cantidad),
                    objTmp.codigoUnidadMedida = parseInt(item.unidad),
                    objTmp.otrosUnidadMedida = item.unidad_medida,
                    objTmp.valor = parseInt(item.valor),
                    objTmp.total = parseFloat(item.total),
                    objTmp.produccionNacional = item.nacional

                    return objTmp;
                });
            }


            data.producto.codigoProducto = null;
            data.producto.codigoUnspsc = null;
            data.producto.codigoFicha = null;
            data.producto.codigoNandina = null;
            data.producto.posicionArancelaria = null;

            var images = document.getElementsByClassName('imagenes');

            this.getBase64(images[0])
                .then(response => {
                    if (!response) {
                        data.producto.imagenProducto = !images[0].parentElement.parentElement.parentElement.getElementsByTagName('img')[0].src.includes('null') ? this.data.imagenProducto : null;
                    } else {
                        data.producto.imagenProducto = response;
                    }
                    return this.getBase64(images[1]);
                })
                .then(response => {
                    if (!response) {
                        data.producto.imagenUbicacionSello = !images[1].parentElement.parentElement.parentElement.getElementsByTagName('img')[0].src.includes('null') ? this.data.imagenUbicacionSello : null;
                    } else {
                        data.producto.imagenUbicacionSello = response;
                    }
                    return this.getBase64(images[2]);
                })
                .then(response => {
                    if (!response) {
                        data.producto.imagenEtiqueta = !images[2].parentElement.parentElement.parentElement.getElementsByTagName('img')[0].src.includes('null') ? this.data.imagenEtiqueta : null;
                    } else {
                        data.producto.imagenEtiqueta = response;
                    }

                    var ubicaciones = '';
                    for (var [key, value] of Object.entries(this.lugaresSeleccionados)) {
                        if (value) {
                            ubicaciones += key + ', ';
                        }
                    }
                    if (ubicaciones.length > 0) {
                        ubicaciones = ubicaciones.trim();
                        ubicaciones = ubicaciones.substring(0, ubicaciones.length - 1);
                    }

                    data.autorizacionSHB = {
                        ubicacionASHB: ubicaciones,
                        otroUbicacionASHB: this.data.autorizacionSHB && this.data.autorizacionSHB.otroUbicacionASHB ? this.data.autorizacionSHB.otroUbicacionASHB : null,
                    }

                    var idCertificacion = this.Storage.get('editCertificacion');
                    if (type === 'SUBMIT') {
                        this.btnSave = true;
                        this.btnSend = true;
                        if (idCertificacion) {
                            const { error } = this.validarImagenes(data.producto, true);
                            if (error) {
                                this.Message.error(error, 'Error de validación');
                                this.btnSave = false;
                                this.btnSend = false;
                                return;
                            }
                            this.DataService.put(`cert_sello_bolivia/solicitarAutorizacion/${idCertificacion}/enviar`, data)
                                .then((response) => {
                                    if (response) {
                                        this.Message.success('La operación se realizo correctamente');
                                        this.Sidenav.path('bandejaSello');
                                    } else {
                                        this.btnSave = false;
                                        this.btnSend = false;
                                    }
                                })
                        } else {
                            this.DataService.post(`cert_sello_bolivia/solicitarAutorizacion`, data)
                            .then((response) => {
                                if (response) {
                                    idCertificacion = response.id_certificacion;
                                    this.Storage.set('editCertificacion', idCertificacion);
                                    const { error } = this.validarImagenes(data.producto, true);
                                    if (error) {
                                        this.Message.error(error, 'Error de validación');
                                        this.btnSave = false;
                                        this.btnSend = false;
                                        return;
                                    }
                                    this.DataService.put(`cert_sello_bolivia/solicitarAutorizacion/${idCertificacion}/enviar`, data)
                                        .then((data) => {
                                            if (data) {
                                                this.Message.success('La operación se realizo correctamente');
                                                this.Sidenav.path('bandejaSello');
                                            } else {
                                                this.btnSave = false;
                                                this.btnSend = false;
                                            }
                                        })
                                } else {
                                    this.btnSave = false;
                                    this.btnSend = false;
                                }
                            })
                        }
                    } else {
                        this.btnSave = true;
                        this.btnSend = true;
                        if (idCertificacion) {
                            const { error } = this.validarImagenes(data.producto);
                            if (error) {
                                this.Message.error(error, 'Error de validación');
                                this.btnSave = false;
                                this.btnSend = false;
                                return;
                            }
                            this.DataService.put(`cert_sello_bolivia/solicitarAutorizacion/${idCertificacion}`, data)
                                .then((response) => {
                                    if (response) {
                                        this.Message.success('Su certificacion ha sido actualizado exitosamente');
                                        this.Sidenav.path('bandejaSello');
                                    } else {
                                        this.btnSave = false;
                                        this.btnSend = false;
                                    }
                                })
                        } else {
                            this.DataService.post(`cert_sello_bolivia/solicitarAutorizacion`, data)
                                .then((response) => {
                                    if (response) {
                                        this.Message.success('Su certificacion se guardo temporalmente de manera exitosa.');
                                        this.Sidenav.path('bandejaSello');
                                    } else {
                                        this.btnSave = false;
                                        this.btnSend = false;
                                    }
                                })
                        }
                    }

                })
        } catch (error) {
            this.btnSave = false;
            this.btnSend = false;
        }
    }

    cargarUnidades() {
        this.DataService.get(`parametros/?grupo=UNIDAD_MEDIDA`)
        .then(response => {
            if (response) {
                let items = [];
                for (let el of response) {
                    items.push({ value: el.id_parametro + "", name: el.nombre });
                }
                this.insumos.data.formly[4].templateOptions.options = items;

                this.renderInsumos = true;
                this.renderPagos = true;
            }
        });
    }

    guardarForm() {
        if (this.data) {
            // if (this.data.nombre_producto && this.data.color && this.data.capacidad_prod_mensual && this.data.precio_unitario) { //jloza
            // if (this.isNotArrayEmpty(this.inputsRequired)) { //oguti
                let data = angular.copy(this.data);

                data.total_costo_bruto = data.total_costo_bruto || 0;
                data.total_valor_costo_bruto = data.total_valor_costo_bruto || 0;
                data.total_distribucion_nacional = 0;
                data.total_distribucion_extranjera = 0;

                delete data.pagos;
                delete data.insumos;
                delete data.certificacion;
                delete data.unidad_productiva;

                this.DataService.put(`certificacion_promueve/${this.certificacion.id_unidad_productiva}/producto`, data);
            // }
        }
    }

    isNotArrayEmpty(array) {
        for (let i in array) {
            if (this.Filter.empty(this.data[array[i]])) {
                return false;
            }
        }

        return true;
    }

    declarar() {
        this.guardarData('SUBMIT');
    }

    getBase64(imagen) {
        var defer = this.$q.defer();
        (function () {
            if (imagen && imagen.files[0]) {
                const reader = new FileReader();
                reader.readAsDataURL(imagen.files[0]);
                reader.onload = function () {
                    defer.resolve(reader.result);
                }
            } else {
                defer.resolve(null);
            }
        })(imagen)
        return defer.promise;
    }

    validarInsumos() {
        var arr = this.insumos.data.list;
        var sw, materia_prima_directa, materia_prima_indirecta, mano_obra, otros;
        for (var i = 0; i < arr.length && !sw; i++) {
            materia_prima_directa = materia_prima_directa || arr[i].tipoItem=='MATERIA_PRIMA_DIRECTA';
            materia_prima_indirecta = materia_prima_indirecta || arr[i].tipoItem=='MATERIA_PRIMA_INDIRECTA';
            mano_obra = mano_obra || arr[i].tipoItem=='MANO_OBRA';
            otros = otros || arr[i].tipoItem=='OTROS_COSTOS';
            sw = materia_prima_indirecta && materia_prima_directa && mano_obra && otros;
        }
        return !sw;
    }

    validarImagenes(producto, required) {
        if (required) {
            if (!producto.imagenProducto) return { error: 'Se requiere la imagen del producto' };
            if (!producto.imagenEtiqueta) return { error: 'Se requiere la imagen de la etiqueta' };
            if (!producto.imagenUbicacionSello) return { error: 'Se requiere la imagen de la unicación del sello' };
        }
        if (producto.imagenProducto && !(producto.imagenProducto.startsWith('data:image/jpeg') || producto.imagenProducto.startsWith('data:image/jpg') || producto.imagenProducto.startsWith('data:image/png') || producto.imagenProducto.startsWith('http'))) {
            return { error: 'Error en el formato de la imagen del producto. Debe seleccionar una imagen de tipo JPG o PNG' };
        }
        if (producto.imagenEtiqueta && !(producto.imagenEtiqueta.startsWith('data:image/jpeg') || producto.imagenEtiqueta.startsWith('data:image/jpg') || producto.imagenEtiqueta.startsWith('data:image/png') || producto.imagenEtiqueta.startsWith('http'))) {
            return { error: 'Error en el formato de la imagen de la etiqueta. Debe seleccionar una imagen de tipo JPG o PNG' };
        }
        if (producto.imagenUbicacionSello && !(producto.imagenUbicacionSello.startsWith('data:image/jpeg') || producto.imagenUbicacionSello.startsWith('data:image/jpg') || producto.imagenUbicacionSello.startsWith('data:image/png') || producto.imagenUbicacionSello.startsWith('http'))) {
            return { error: 'Error en el formato de la imagen de la ubicación del sello. Debe seleccionar una imagen de tipo JPG o PNG' };
        }
        return { error: null };
    }

    limpiarDependenciaUbicacion(key, value) {
        if (key === 'OTROS' && !value) {
            this.data.autorizacionSHB.otroUbicacionASHB = '';
        }
    }
}

export default FormularioEmpController;



// WEBPACK FOOTER //
// ./src/app/components/promueve/empresario/autorizacion/certificacion.promueve.controller.js